import React from "react";
import { Text } from "@amzn/meridian";
import { Scanner } from "@yudiel/react-qr-scanner";

interface BarcodeScannerProps {
  isScanning: boolean;
  onScan: (result: any) => void;
  onError: (error: any) => void;
  idealHeight: number;
  idealWidth: number;
}

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({
  isScanning,
  onScan,
  onError,
  idealHeight,
  idealWidth
}) => {

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {isScanning && (
        <Scanner
          onScan={onScan}
          onError={onError}
          formats={['code_128']}
          components={{finder: false}}
          allowMultiple={false}
          constraints={{
            facingMode: "environment",
            width: { ideal: idealWidth },
            height: { ideal: idealHeight },
          }}
          styles={{
            container: {
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
            },
          }}
        />
      )}

      {/* Scanning Frame Overlay */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          maxWidth: "700px",
          height: "50%",
          border: "3px solid #00A650",
          borderRadius: "12px",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      {/* Status Text */}
      <div
        style={{
          position: "absolute",
          bottom: "20%",
          left: "0",
          right: "0",
          zIndex: 2,
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        <Text color="inverted" type="h300" alignment="center">
          {isScanning ? "Position barcode within frame" : "Processing..."}
        </Text>
      </div>
    </div>
  );
};

export default BarcodeScanner;
